import { Box, TextField } from "@mui/material"
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useEffect, useState } from "react"
import { formatDateTime, getCurrentDate } from "../lib/time"

export const TimeFieldComponent = (props: any) => {
    const { field, fieldValue, onDataEntry ,onCancel } = props
    const [time, setTime] = useState<string | null>(fieldValue || getCurrentDate() + ' ' + field.defaultValue)
    const [validTime, setValidTime] = useState<boolean>(true)
    const [pickerOpen, setPickerOpen] = useState<boolean>(false)
    const [initialPopupOpen, setInitialPopupOpen] = useState<boolean>(true)

    const isValidTime = (newTime: string | null) => {
      return /^[A-Z][a-z]{2}, \d{2} [A-Z][a-z]{2} \d{4} \d{2}:\d{2}:\d{2} GMT$/.test(newTime || '');
  }
  
  const onTimeChange = (newTime: string | null) => {
    if (isValidTime(newTime)) {
      setTime(newTime);
      setValidTime(true);
    } else {
      setValidTime(false);
    }
  }

    useEffect(() => {
      if (time && !initialPopupOpen) {
        onDataEntry(formatDateTime(time), field.name)
    }
    }, [time, onDataEntry, field])

    const handleClose = () => {
      if (validTime) { 
        setPickerOpen(false);
        setInitialPopupOpen(false);
      }
    };
    const handleAccept = (newTime: string | null) => {
      if (isValidTime(newTime)) {
        setTime(newTime);
        setPickerOpen(false);
        setInitialPopupOpen(false);
        setValidTime(true);
      } else {
        setValidTime(false);
      }
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileTimePicker
          label=""
          value={time}
          open={pickerOpen}
          onChange={(newTime) => onTimeChange(newTime)}
          onOpen={() => setPickerOpen(true)}
          onClose={handleClose}
          onAccept={(newTime) => handleAccept(newTime)}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                error={!validTime}
                onChange={(event) => {
                  const newTime = event.target.value;
                  setValidTime(isValidTime(newTime));
                  setTime(newTime);
                }}
              />
              {!validTime && (
                <Box flex={0} marginRight={10} fontSize={12} marginTop={"5px"} color="red">
                  Invalid time format
                </Box>
              )}
            </>
          )}
        />
      </LocalizationProvider>
    );
  };

export default TimeFieldComponent
